<template>
    <div>
        <div id="perkin-individu" class="card mb-1 shadow-none border border-1 ">
            <div class="card-header border-bottom mb-1">
                <div class="card-title">
                    <span class="text-primary text-uppercase">
                        Perkin Individu
                    </span>
                </div>
            </div>
            <div class="card-body overflow-auto">
                <div class="mb-2">
                    <div class="text-nowrap mb-25 d-flex justify-content-start">
                        <span class="align-text-top font-small-5">
                            {{ fD.kolok + ' - ' + fD.nalok }}</span>
                    </div>
                </div>
                <b-overlay :show="loadingData" variant="light" opacity="0.85" blur="2px" rounded="sm">
                    <div class="overflow-auto">
                        <table class="table table-bordered table-hover-cell mb-2">
                            <thead class="table-primary font-weight-bolder">
                                <tr style="font-size: 16px;">
                                    <td colspan="2" class="text-center" style="min-width: 275px;">KEGIATAN</td>
                                    <td colspan="2" class="text-center">TW I (5%)</td>
                                    <td colspan="2" class="text-center">TW II (25%)</td>
                                    <td colspan="2" class="text-center">TW III (55%)</td>
                                    <td colspan="2" class="text-center">TW IV (100%)</td>
                                    <td colspan="2" class="text-center">TW I - 2025</td>
                                </tr>
                            </thead>
                            <tbody style="font-size: 12px;" class="text-right">
                                <!-- Start Persiapan -->
                                <tr>
                                    <td rowspan="3" class="font-weight-bolder">Persiapan (5%)</td>
                                    <td class="font-weight-bolder">SK TIM</td>
                                    <td id="persiapan_sktim_tw_1"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_sk_tim_tw_1)"
                                            :class="valueClass(perkinData.persiapan_sk_tim_tw_1)" size="20" /></td>
                                    <td id="persiapan_tw_1" rowspan="3">{{ perkinData.persiapan_tw_1 }}%</td>
                                    <td id="persiapan_sktim_tw_2"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_sk_tim_tw_2)"
                                            :class="valueClass(perkinData.persiapan_sk_tim_tw_2)" size="20" /></td>
                                    <td id="persiapan_tw_2" rowspan="3">{{ perkinData.persiapan_tw_2 }}%</td>
                                    <td id="persiapan_sktim_tw_3"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_sk_tim_tw_3)"
                                            :class="valueClass(perkinData.persiapan_sk_tim_tw_3)" size="20" /></td>
                                    <td id="persiapan_tw_3" rowspan="3">{{ perkinData.persiapan_tw_3 }}%</td>
                                    <td id="persiapan_sktim_tw_4"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_sk_tim_tw_4)"
                                            :class="valueClass(perkinData.persiapan_sk_tim_tw_4)" size="20" /></td>
                                    <td id="persiapan_tw_5" rowspan="3">{{ perkinData.persiapan_tw_4 }}%</td>
                                    <td id="persiapan_sktim_tw_5"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_sk_tim_tw_5)"
                                            :class="valueClass(perkinData.persiapan_sk_tim_tw_5)" size="20" /></td>
                                    <td id="persiapan_tw_5" rowspan="3">{{ perkinData.persiapan_tw_5 }}%</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Ruangan</td>
                                    <td id="persiapan_ruang_tw_1"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_ruang_tw_1)"
                                            :class="valueClass(perkinData.persiapan_ruang_tw_1)" size="20" /></td>
                                    <td id="persiapan_ruang_tw_2"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_ruang_tw_2)"
                                            :class="valueClass(perkinData.persiapan_ruang_tw_2)" size="20" /></td>
                                    <td id="persiapan_ruang_tw_3"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_ruang_tw_3)"
                                            :class="valueClass(perkinData.persiapan_ruang_tw_3)" size="20" /></td>
                                    <td id="persiapan_ruang_tw_4"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_ruang_tw_4)"
                                            :class="valueClass(perkinData.persiapan_ruang_tw_4)" size="20" /></td>
                                    <td id="persiapan_ruang_tw_5"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_ruang_tw_5)"
                                            :class="valueClass(perkinData.persiapan_ruang_tw_5)" size="20" /></td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Daftar BMD</td>
                                    <td id="persiapan_bmd_tw_1"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_bmd_tw_1)"
                                            :class="valueClass(perkinData.persiapan_bmd_tw_1)" size="20" /></td>
                                    <td id="persiapan_bmd_tw_2"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_bmd_tw_2)"
                                            :class="valueClass(perkinData.persiapan_bmd_tw_2)" size="20" /></td>
                                    <td id="persiapan_bmd_tw_3"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_bmd_tw_3)"
                                            :class="valueClass(perkinData.persiapan_bmd_tw_3)" size="20" /></td>
                                    <td id="persiapan_bmd_tw_4"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_bmd_tw_4)"
                                            :class="valueClass(perkinData.persiapan_bmd_tw_4)" size="20" /></td>
                                    <td id="persiapan_bmd_tw_5"><feather-icon
                                            :icon="valueIcon(perkinData.persiapan_bmd_tw_5)"
                                            :class="valueClass(perkinData.persiapan_bmd_tw_5)" size="20" /></td>
                                </tr>
                                <!-- End Persiapan -->
                                <!-- Start Pelaksanaan -->
                                <tr>
                                    <td class="font-weight-bolder border-row">Pelaksanaan (85%)</td>
                                    <td class="font-weight-bolder">Selesai Inventarisasi</td>
                                    <td style="min-width: 110px;">
                                        <div>
                                            {{ perkinData.pelaksanaan_selesai_inven_tw1 }}
                                        </div>
                                        <div class="bmd-overline">{{ perkinData.pelaksanaan_total_bmd_tw1 }}</div>
                                    </td>
                                    <td id="pelaksanaan_tw_1">{{ perkinData.pelaksanaan_tw_1 }}%</td>
                                    <td style="min-width: 110px;">
                                        <div>
                                            {{ perkinData.pelaksanaan_selesai_inven_tw2 }}
                                        </div>
                                        <div class="bmd-overline">{{ perkinData.pelaksanaan_total_bmd_tw2 }}</div>
                                    </td>
                                    <td id="pelaksanaan_tw_2">{{ perkinData.pelaksanaan_tw_2 }}%</td>
                                    <td style="min-width: 110px;">
                                        <div>
                                            {{ perkinData.pelaksanaan_selesai_inven_tw3 }}
                                        </div>
                                        <div class="bmd-overline">{{ perkinData.pelaksanaan_total_bmd_tw3 }}</div>
                                    </td>
                                    <td id="pelaksanaan_tw_3">{{ perkinData.pelaksanaan_tw_3 }}%</td>
                                    <td style="min-width: 110px;">
                                        <div>
                                            {{ perkinData.pelaksanaan_selesai_inven_tw4 }}
                                        </div>
                                        <div class="bmd-overline">{{ perkinData.pelaksanaan_total_bmd_tw4 }}</div>
                                    </td>
                                    <td id="pelaksanaan_tw_4">{{ perkinData.pelaksanaan_tw_4 }}%</td>
                                    <td style="min-width: 110px;">
                                        <div>
                                            {{ perkinData.pelaksanaan_selesai_inven_tw5 }}
                                        </div>
                                        <div class="bmd-overline">{{ perkinData.pelaksanaan_total_bmd_tw5 }}</div>
                                    </td>
                                    <td id="pelaksanaan_tw_5">{{ perkinData.pelaksanaan_tw_5 }}%</td>
                                </tr>
                                <!-- End Pelaksanaan -->
                                <!-- Start Pelaporan -->
                                <tr>
                                    <td rowspan="3" class="font-weight-bolder">Pelaporan (10%)</td>
                                    <td class="font-weight-bolder">Berita Acara</td>
                                    <td id="pelaporan_ba_tw_1"><feather-icon :icon="valueIcon(perkinData.pelaporan_ba_tw_1)"
                                            :class="valueClass(perkinData.pelaporan_ba_tw_1)" size="20" /></td>
                                    <td id="pelaporan_tw1" rowspan="3">{{ perkinData.pelaporan_tw1 }}%</td>
                                    <td id="pelaporan_ba_tw_2"><feather-icon :icon="valueIcon(perkinData.pelaporan_ba_tw_2)"
                                            :class="valueClass(perkinData.pelaporan_ba_tw_2)" size="20" /></td>
                                    <td id="pelaporan_tw2" rowspan="3">{{ perkinData.pelaporan_tw2 }}%</td>
                                    <td id="pelaporan_ba_tw_3"><feather-icon :icon="valueIcon(perkinData.pelaporan_ba_tw_3)"
                                            :class="valueClass(perkinData.pelaporan_ba_tw_3)" size="20" /></td>
                                    <td id="pelaporan_tw3" rowspan="3">{{ perkinData.pelaporan_tw3 }}%</td>
                                    <td id="pelaporan_ba_tw_4"><feather-icon :icon="valueIcon(perkinData.pelaporan_ba_tw_4)"
                                            :class="valueClass(perkinData.pelaporan_ba_tw_4)" size="20" /></td>
                                    <td id="pelaporan_tw4" rowspan="3">{{ perkinData.pelaporan_tw4 }}%</td>
                                    <td id="pelaporan_ba_tw_5"><feather-icon :icon="valueIcon(perkinData.pelaporan_ba_tw_5)"
                                            :class="valueClass(perkinData.pelaporan_ba_tw_5)" size="20" /></td>
                                    <td id="pelaporan_tw5" rowspan="3">{{ perkinData.pelaporan_tw5 }}%</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">SPTJM</td>
                                    <td id="pelaporan_sptjm_tw_1"><feather-icon
                                            :icon="valueIcon(perkinData.pelaporan_sptjm_tw_1)"
                                            :class="valueClass(perkinData.pelaporan_sptjm_tw_1)" size="20" /></td>
                                    <td id="pelaporan_sptjm_tw_2"><feather-icon
                                            :icon="valueIcon(perkinData.pelaporan_sptjm_tw_2)"
                                            :class="valueClass(perkinData.pelaporan_sptjm_tw_2)" size="20" /></td>
                                    <td id="pelaporan_sptjm_tw_3"><feather-icon
                                            :icon="valueIcon(perkinData.pelaporan_sptjm_tw_3)"
                                            :class="valueClass(perkinData.pelaporan_sptjm_tw_3)" size="20" /></td>
                                    <td id="pelaporan_sptjm_tw_4"><feather-icon
                                            :icon="valueIcon(perkinData.pelaporan_sptjm_tw_4)"
                                            :class="valueClass(perkinData.pelaporan_sptjm_tw_4)" size="20" /></td>
                                    <td id="pelaporan_sptjm_tw_5"><feather-icon
                                            :icon="valueIcon(perkinData.pelaporan_sptjm_tw_5)"
                                            :class="valueClass(perkinData.pelaporan_sptjm_tw_5)" size="20" /></td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Laporan Hasil Inventarisasi (LHI)</td>
                                    <td id="pelaporan_lhi_tw_1"><feather-icon
                                            :icon="valueIcon(perkinData.pelaporan_lhi_tw_1)"
                                            :class="valueClass(perkinData.pelaporan_lhi_tw_1)" size="20" /></td>
                                    <td id="pelaporan_lhi_tw_2"><feather-icon
                                            :icon="valueIcon(perkinData.pelaporan_lhi_tw_2)"
                                            :class="valueClass(perkinData.pelaporan_lhi_tw_2)" size="20" /></td>
                                    <td id="pelaporan_lhi_tw_3"><feather-icon
                                            :icon="valueIcon(perkinData.pelaporan_lhi_tw_3)"
                                            :class="valueClass(perkinData.pelaporan_lhi_tw_3)" size="20" /></td>
                                    <td id="pelaporan_lhi_tw_4"><feather-icon
                                            :icon="valueIcon(perkinData.pelaporan_lhi_tw_4)"
                                            :class="valueClass(perkinData.pelaporan_lhi_tw_4)" size="20" /></td>
                                    <td id="pelaporan_lhi_tw_5"><feather-icon
                                            :icon="valueIcon(perkinData.pelaporan_lhi_tw_5)"
                                            :class="valueClass(perkinData.pelaporan_lhi_tw_5)" size="20" /></td>
                                </tr>
                                <!-- End Pelaporan -->
                            </tbody>
                            <tfoot class="bg-secondary" style="font-weight: bolder;">
                                <tr class="text-white text-right">
                                    <td colspan="2">Akumulasi Pembobotan</td>
                                    <td id="akumulasi_bobot_tw_1" colspan="2">{{ perkinData.akumulasi_bobot_tw_1 }}%
                                    </td>
                                    <td id="akumulasi_bobot_tw_2" colspan="2">{{ perkinData.akumulasi_bobot_tw_2 }}%
                                    </td>
                                    <td id="akumulasi_bobot_tw_3" colspan="2">{{ perkinData.akumulasi_bobot_tw_3 }}%
                                    </td>
                                    <td id="akumulasi_bobot_tw_4" colspan="2">{{ perkinData.akumulasi_bobot_tw_4 }}%
                                    </td>
                                    <td id="akumulasi_bobot_tw_5" colspan="2">{{ perkinData.akumulasi_bobot_tw_5 }}%
                                    </td>
                                </tr>
                                <tr class="text-white text-right">
                                    <td colspan="2">Akumulasi Per-TW
                                        <sup><feather-icon icon="InfoIcon" class="text-white" size="10"
                                                v-b-tooltip.hover.right
                                                title="Akumulasi Bobot dibagi Bobot TW dikali 100%" /></sup>
                                    </td>
                                    <td id="akumulasi_pertw_tw_1" colspan="2">{{ perkinData.akumulasi_pertw_tw_1 }}%
                                    </td>
                                    <td id="akumulasi_pertw_tw_2" colspan="2">{{ perkinData.akumulasi_pertw_tw_2 }}%
                                    </td>
                                    <td id="akumulasi_pertw_tw_3" colspan="2">{{ perkinData.akumulasi_pertw_tw_3 }}%
                                    </td>
                                    <td id="akumulasi_pertw_tw_4" colspan="2">{{ perkinData.akumulasi_pertw_tw_4 }}%
                                    </td>
                                    <td id="akumulasi_pertw_tw_5" colspan="2">{{ perkinData.akumulasi_pertw_tw_5 }}%
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </b-overlay>
            </div>
        </div>
    </div>
</template>
  
<script>
import { ref, watch, watchEffect, onMounted } from '@vue/composition-api'
import vSelect from "vue-select";
import { id as localeId } from "vee-validate/dist/locale/id";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import masterBRef from "@/composables/master/masterBRef";
import { showNotifikasi } from '@/libs/helper';
import { VueGoodTable } from "vue-good-table";
import { parserValue } from '@/libs/helper'
import moment from 'moment';

export default {
    props: {
        fD: {
            type: Object,
            required: true,
        },
        perkinData: {
            type: Object,
            required: true,
        },
        loadingData: {
            type: Boolean,
            required: true,
        }
    },
    setup(props, context) {
        const g = context.root;
        /* Dataset */

        const valueIcon = (value) => {
            if (value) {
                return 'CheckIcon';
            } else {
                return 'XIcon';
            }
        }

        const valueClass = (value) => {
            let v = (value) ? 'text-success' : 'text-danger';
            return v;
        }

        return {
            valueIcon,
            valueClass
        }
    },
    computed: {
    },
    components: {
    },
    directives: {
        Ripple,
    },
    methods: {
    },

    data() {
        return {
            required,
        }
    },
}
</script>

<style lang="scss" scoped>
.table-hover-cell tbody tr td:hover {
    background-color: #d9d9d9;
}

.bmd-overline {
    text-decoration: overline;
}
</style>